/**
 * Campo de estrellas con glow + deriva suave.
 * Fade-in al cargar; scroll con decay mínimo (lerp) para movimiento más smooth.
 */
(function () {
  var canvas = document.getElementById('clash-space-stars');
  if (!canvas) return;

  var ctx = canvas.getContext('2d');
  var stars = [];
  var tile = 650;
  var layerOffsets = [0, 0, 0];
  var layerSpeeds = [0.0025, 0.005, 0.009];
  var lastTime = 0;
  var dpr = 1;
  var scrollY = 0;

  var fadeDuration = 250;
  var fadeStart = 0;
  var fadeDone = false;
  var fadeTarget = 0.22;

  var palette = [
    '255,255,255',
    '165,243,252',
    '110,231,183',
    '196,181,253',
    '103,232,249'
  ];

  function rand(min, max) {
    return min + Math.random() * (max - min);
  }

  function readFadeTarget() {
    var raw = getComputedStyle(document.documentElement)
      .getPropertyValue('--space-stars-opacity')
      .trim();
    var n = parseFloat(raw);
    fadeTarget = isFinite(n) ? n : 0.22;
  }

  function buildStars() {
    stars = [];

    var counts = [14, 8, 4];
    var sizes = [[0.45, 0.8], [0.7, 1.15], [1, 1.55]];
    var glowRadii = [[20, 28], [26, 36], [32, 44]];
    var coreAlpha = [0.45, 0.68, 0.9];
    var glowAlpha = [0.055, 0.075, 0.095];

    for (var depth = 0; depth < counts.length; depth++) {
      for (var i = 0; i < counts[depth]; i++) {
        var color = palette[Math.floor(Math.random() * palette.length)];
        stars.push({
          depth: depth,
          x: Math.random() * tile,
          y: Math.random() * tile,
          size: rand(sizes[depth][0], sizes[depth][1]),
          glowR: rand(glowRadii[depth][0], glowRadii[depth][1]),
          core: 'rgba(' + color + ',' + coreAlpha[depth] + ')',
          glow: 'rgba(' + color + ',' + glowAlpha[depth] + ')',
          glowDim: 'rgba(' + color + ',0.012)'
        });
      }
    }
  }

  function resize() {
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.ceil(window.innerWidth * dpr);
    canvas.height = Math.ceil(window.innerHeight * dpr);
    canvas.style.width = window.innerWidth + 'px';
    canvas.style.height = window.innerHeight + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function readScroll() {
    scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function updateFade(time) {
    if (fadeDone) return;
    if (!fadeStart) fadeStart = time;
    var t = Math.min(1, (time - fadeStart) / fadeDuration);
    var eased = 1 - Math.pow(1 - t, 2);
    canvas.style.opacity = String(fadeTarget * eased);
    if (t >= 1) fadeDone = true;
  }

  function drawStar(x, y, star) {
    var g = ctx.createRadialGradient(x, y, 0, x, y, star.glowR);
    g.addColorStop(0, star.glow);
    g.addColorStop(0.35, star.glowDim);
    g.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = g;
    ctx.beginPath();
    ctx.arc(x, y, star.glowR, 0, Math.PI * 2);
    ctx.fill();

    ctx.beginPath();
    ctx.arc(x, y, star.size, 0, Math.PI * 2);
    ctx.fillStyle = star.core;
    ctx.fill();
  }

  function draw() {
    var w = window.innerWidth;
    var h = window.innerHeight;
    ctx.clearRect(0, 0, w, h);

    var cols = Math.ceil(w / tile) + 2;
    var rows = Math.ceil(h / tile) + 3;
    var baseRow = Math.floor(scrollY / tile) - 1;

    for (var i = 0; i < stars.length; i++) {
      var star = stars[i];
      var shiftedX = (star.x + layerOffsets[star.depth] + tile) % tile;

      for (var col = -1; col < cols; col++) {
        for (var row = 0; row < rows; row++) {
          var worldY = (baseRow + row) * tile + star.y;
          drawStar(col * tile + shiftedX, worldY - scrollY, star);
        }
      }
    }
  }

  function tick(time) {
    var delta = lastTime ? Math.min(time - lastTime, 32) : 16.67;
    lastTime = time;

    for (var i = 0; i < layerOffsets.length; i++) {
      layerOffsets[i] -= layerSpeeds[i] * delta;
      if (layerOffsets[i] <= -tile) layerOffsets[i] += tile;
    }

    updateFade(time);
    draw();
    requestAnimationFrame(tick);
  }

  function applyStarsOpacity() {
    readFadeTarget();
    if (fadeDone) {
      canvas.style.opacity = String(fadeTarget);
    }
  }

  canvas.style.opacity = '0';
  readFadeTarget();
  buildStars();
  resize();
  readScroll();

  window.addEventListener('resize', function () {
    resize();
    applyStarsOpacity();
  }, { passive: true });
  window.addEventListener('scroll', readScroll, { passive: true });
  requestAnimationFrame(tick);
})();
